import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HamburgerMenu from "./HamburgerMenu";
import pricingBackground from "./assets/pricingbackground.png";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((open) => !open);

  return (
    <div className="min-h-screen text-white font-[Montserrat] flex flex-col bg-black sm:bg-transparent relative">
      {/* Full background image on desktop only */}
      <div
        className="hidden sm:block absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${pricingBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Header Bar */}
      <nav className="flex justify-end items-center px-6 py-4 relative z-20">
        <HamburgerMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
      </nav>

      {/* Centered Section */}
      <section className="flex-grow flex items-center justify-center relative z-10">
        <div className="rounded-2xl bg-black bg-opacity-80 p-10 w-full max-w-2xl text-white text-center">
          <h2 className="text-3xl font-extrabold mb-6 tracking-tight">
            Verify Your Email
          </h2>
          <p className="text-lg mb-10 px-4 font-semibold">
            A verification link has been sent to your email. Please click it to
            verify your account. Once you’ve done that, return here and click
            the button below.
          </p>
          <button
            onClick={() => navigate("/verify-confirm")}
            className="px-6 py-3 bg-white text-black font-bold rounded-lg text-lg hover:bg-gray-200 transition-colors"
          >
            I’ve Verified My Email
          </button>
        </div>
      </section>

      {/* Footer links */}
      <footer className="py-6 text-sm text-gray-400 text-center relative z-10">
        <div className="flex justify-center gap-2">
          <a href="/help" className="hover:underline">
            Help
          </a>
          <span>|</span>
          <a href="/terms-of-service" className="hover:underline">
            Terms of Service
          </a>
          <span>|</span>
          <a href="/contact" className="hover:underline">
            Contact
          </a>
        </div>
      </footer>
    </div>
  );
}
